import React from 'react'
import propTypes from 'prop-types';

const DropCap = ({paragraph, elClass}) => {
	return (
		<div className={`${elClass}__container main-grid`}>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<div 
					className={`${elClass} large-text drop-cap`}
					dangerouslySetInnerHTML={{__html: paragraph}}
				></div>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default DropCap;

DropCap.propTypes = {
	paragraph: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired
}